<script setup lang="ts">
import { tw } from "../../../utils/tailwind";
import CarouselButton from "../../ui/carousel/CarouselButton.vue";
import type { WithClassAsProps } from "../../ui/carousel/interface";
import { useCarousel } from "../../ui/carousel/useCarousel";

const props = defineProps<WithClassAsProps>();

const { orientation, canScrollPrev, scrollPrev } = useCarousel();
</script>

<template>
  <CarouselButton
    :disabled="!canScrollPrev"
    :class="tw(
      'touch-manipulation disabled:opacity-50',
      props.class,
    )"
    variant="outline"
    @click="scrollPrev"
  >
    <slot>
        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 43 43" fill="none">
            <path d="M18 26L14 22L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M29 22L14 22" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="sr-only">Previous Slide</span>
    </slot>
  </CarouselButton>
</template>
